import { useWorkspaceSettings } from "@/hooks/use-workspace-settings";
import { useLookbookVisibilityStore } from "@/store/lookbook-visibility-store";
import { LookbookVisibilityDialog } from "./lookbook-visibility-dialog";
import { useAddToBoard } from "./use-add-to-board";

/**
 * Renders the visibility dialog for whatever add is pending.
 *
 * Mounted once, high enough up to be a sibling of the add-to-board dropdowns
 * rather than a descendant: Radix unmounts a menu's whole subtree when the menu
 * closes, so a dialog opened from inside one would disappear the moment it
 * appeared.
 */
export function LookbookVisibilityHost() {
  const pending = useLookbookVisibilityStore((s) => s.pending);
  const close = useLookbookVisibilityStore((s) => s.close);
  const { activeWorkspaceId } = useWorkspaceSettings();

  const { isPending, commitLookbook, commitNewLookbook } = useAddToBoard(
    pending?.onDone
  );

  if (!pending || !activeWorkspaceId) return null;

  return (
    <LookbookVisibilityDialog
      open
      onOpenChange={(open) => {
        if (!open && !isPending) close();
      }}
      mode={pending.mode}
      lookbookId={pending.lookbookId}
      lookbookName={pending.lookbookName}
      companyIds={pending.companyIds}
      workspaceId={activeWorkspaceId}
      isSaving={isPending}
      onConfirm={({ name, visibility }) => {
        if (pending.mode === "create") {
          commitNewLookbook({
            name,
            companyIds: pending.companyIds,
            visibility,
          });
          return;
        }
        commitLookbook({
          lookbookId: pending.lookbookId as string,
          name: pending.lookbookName,
          companyIds: pending.companyIds,
          visibility,
        });
      }}
    />
  );
}
